const SB_MONO = "https://customer-assets.emergentagent.com/job_af8f5b12-cd02-481d-8aac-658ba1fd8e83/artifacts/uzu8frqy_mono.png";

export default function Footer() {
    return (
        <footer className="relative border-t border-sb py-14 md:py-20" data-testid="footer">
            <div className="mx-auto max-w-[1480px] px-6 sm:px-12 md:px-20">
                {/* Top mega mark */}
                <div className="flex items-end justify-between gap-8 pb-12 border-b border-sb">
                    <a href="#hero" data-testid="footer-logo-link" className="flex items-center gap-3">
                        <img src={SB_MONO} alt="" className="h-9 w-9 rounded-md" />
                        <div className="flex flex-col leading-none">
                            <span className="font-serif text-[32px] md:text-[44px] text-sb tracking-tight leading-none">sysbrains</span>
                            <span className="mt-2 font-mono text-[10px] uppercase tracking-[0.28em] text-sb-muted">
                                Built with clarity.
                            </span>
                        </div>
                    </a>

                    <a
                        href="#contact"
                        className="hidden md:inline-flex items-center gap-2 rounded-full border-sb border px-5 py-2 text-xs font-mono uppercase tracking-[0.22em] text-sb-soft hover:border-sb-mint hover:text-sb-mint transition-colors"
                    >
                        <span>Begin a project</span>
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1 9L9 1M9 1H2M9 1V8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </a>
                </div>

                <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-8">
                    <div>
                        <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-sb-muted">Index</div>
                        <ul className="mt-4 space-y-2 text-sm text-sb-soft">
                            <li><a href="#about" data-testid="footer-link-about" className="hover:text-sb-mint transition-colors">About</a></li>
                            <li><a href="#capabilities" data-testid="footer-link-capabilities" className="hover:text-sb-mint transition-colors">Capabilities</a></li>
                            <li><a href="#philosophy" data-testid="footer-link-philosophy" className="hover:text-sb-mint transition-colors">Philosophy</a></li>
                            <li><a href="#contact" data-testid="footer-link-contact" className="hover:text-sb-mint transition-colors">Contact</a></li>
                        </ul>
                    </div>
                    <div>
                        <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-sb-muted">Studio</div>
                        <ul className="mt-4 space-y-2 text-sm text-sb-soft">
                            <li>Independent</li>
                            <li>Est. 2025</li>
                            <li>Remote · global</li>
                        </ul>
                    </div>
                    <div>
                        <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-sb-muted">Contact</div>
                        <ul className="mt-4 space-y-2 text-sm text-sb-soft">
                            <li><a href="mailto:contact@sysbrains.com" className="hover:text-sb-mint transition-colors">contact@sysbrains.com</a></li>
                            <li className="text-sb-muted">Reply in 1–2 days</li>
                        </ul>
                    </div>
                    <div>
                        <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-sb-muted">Colophon</div>
                        <ul className="mt-4 space-y-2 text-sm text-sb-soft">
                            <li>Instrument Serif</li>
                            <li>Inter Tight</li>
                            <li>JetBrains Mono</li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 flex flex-wrap items-center justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.24em] text-sb-muted">
                    <span>© {new Date().getFullYear()} SysBrains. All rights reserved</span>
                    <span className="flex items-center gap-2">
                        <span className="h-1.5 w-1.5 rounded-full bg-sb-mint sb-pulse" />
                        Open to select partnerships
                    </span>
                </div>
            </div>
        </footer>
    );
}
